import { useMemo } from 'react';

import { useTermsOfServiceBanner } from '../termsOfService';

import type { Banner } from './types';

export function useOrderedBanners(): readonly Banner[] {
	const {
		isTermsOfServiceBannerDisplayed,
		dismissTermsOfServiceBanner,
		termsOfServiceBannerCopy,
		handleTermsOfServiceBannerView,
		trackTermsOfServiceLinkClick,
	} = useTermsOfServiceBanner();

	return useMemo(() => {
		const banners: Banner[] = [];
		if (isTermsOfServiceBannerDisplayed)
			banners.push({
				type: 'tos',
				dismiss: dismissTermsOfServiceBanner,
				handleView: handleTermsOfServiceBannerView,
				trackLinkClick: trackTermsOfServiceLinkClick,
				copy: termsOfServiceBannerCopy,
			});
		return banners;
	}, [
		isTermsOfServiceBannerDisplayed,
		dismissTermsOfServiceBanner,
		termsOfServiceBannerCopy,
		handleTermsOfServiceBannerView,
		trackTermsOfServiceLinkClick,
	]);
}
